import React from 'react'

type Props = {
  //
}

const LiveStreamWrapper: React.FC<Props> = () => (
  <div className="row">
    <div className="video-item off col-md-7 col-sx-12">
      <div className="camera-name">カメラ1</div>
      <div className="video-status">OFF</div>
      <div className="video-play">
        <img src="/assets/img/video-screen.png" alt="" style={{ opacity: 0 }} />
      </div>
    </div>
    <div className="col-xs-12 col-md-5">
      <button type="button" className="btn btn-common btn-outline-primary btn-block">LIVE配信を終了する</button>
      <div className="card mt-3 live-info">
        <div className="card-header text-center">
          <i className="fas fa-user">{' '}</i>
          <span>LIVE観覧者数</span>
        </div>
        <div className="card-body live-viewer">
          <div className="row no-gutters">
            <div className="col-6 text-center">
              <h3>現在</h3>
              <div>
                <span>5</span>人
              </div>
            </div>
            <div className="col-6 text-center">
              <h3>累計</h3>
              <div>
                <span>15</span>人
              </div>
            </div>
          </div>
        </div>
        <div className="card-header text-center">
          <i className="fas fa-user">{' '}</i>
          <span>LIVE観覧人数ランキング</span>
        </div>
        <div className="card-body live-ranking">
          <div className="row no-gutters">
            <div className="col-6 text-center">
              <div>
                <span>1</span>位
              </div>
            </div>
            <div className="col-6 text-center">
              <div>
                <span>7</span>店
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default LiveStreamWrapper
